/**
 * Shopify collection default availability preselection.
 *
 * If at least one filter is active and the availability filter is not set,
 * force `filter.v.availability=1` (in stock only).
 *
 * Works with both full-page reload themes and AJAX/pushState themes.
 */
(function preselectAvailabilityFilter() {
  if (typeof window === 'undefined') return;

  var AVAILABILITY_KEY = 'filter.v.availability';
  var AVAILABILITY_VALUE = '1';

  function isCollectionPath(pathname) {
    return /^\/collections(\/|$)/.test(pathname || '');
  }

  function hasAnyFilter(searchParams) {
    var found = false;

    searchParams.forEach(function (_value, key) {
      if (key.indexOf('filter.') === 0) {
        found = true;
      }
    });

    return found;
  }

  function buildEnforcedUrl(href) {
    var url = new URL(href, window.location.origin);

    if (!isCollectionPath(url.pathname)) return null;
    if (!hasAnyFilter(url.searchParams)) return null;
    if (url.searchParams.has(AVAILABILITY_KEY)) return null;

    url.searchParams.set(AVAILABILITY_KEY, AVAILABILITY_VALUE);
    return url.toString();
  }

  function enforceAvailability() {
    var nextUrl = buildEnforcedUrl(window.location.href);
    if (!nextUrl) return;

    // Hard redirect ensures compatibility with custom templates and AJAX filters.
    window.location.replace(nextUrl);
  }

  // Initial check.
  enforceAvailability();

  // Re-check when browser navigation happens.
  window.addEventListener('popstate', enforceAvailability);
  window.addEventListener('hashchange', enforceAvailability);

  // Re-check when themes update the URL via History API (AJAX facets).
  var originalPushState = window.history.pushState;
  var originalReplaceState = window.history.replaceState;

  window.history.pushState = function () {
    originalPushState.apply(window.history, arguments);
    enforceAvailability();
  };

  window.history.replaceState = function () {
    originalReplaceState.apply(window.history, arguments);
    enforceAvailability();
  };

  // Extra safety for themes that change URL in custom ways.
  var lastHref = window.location.href;
  window.setInterval(function () {
    var currentHref = window.location.href;
    if (currentHref === lastHref) return;

    lastHref = currentHref;
    enforceAvailability();
  }, 300);
})();